import { render, staticRenderFns } from "./paymentStatus.vue?vue&type=template&id=3cfe533c&scoped=true&lang=pug&"
import script from "./paymentStatus.vue?vue&type=script&lang=js&"
export * from "./paymentStatus.vue?vue&type=script&lang=js&"
import style0 from "./paymentStatus.vue?vue&type=style&index=0&id=3cfe533c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfe533c",
  null
  
)

export default component.exports